import monaco from './monaco/index.js';
export { default } from './monaco/index.js';
